// extracted by mini-css-extract-plugin
export var bottomGrid = "index-module--bottom-grid--b2523";
export var mainContainer = "index-module--main-container--b3bba";
export var mainContent = "index-module--main-content--264e7";
export var mainWrapper = "index-module--main-wrapper--89e1f";
export var topGrid = "index-module--top-grid--48d18";